import { render, staticRenderFns } from "./CardSectionAwardsGrid.vue?vue&type=template&id=759aa9c3"
import script from "./CardSectionAwardsGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardSectionAwardsGrid.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports